module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "height": "100%",
      "isShowMask": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "v5-checklist-content"
  }, [_c('div', {
    staticClass: "v5-checklist-header"
  }, [_c('div', {
    staticClass: "v5-checklist-header-content"
  }, [_c('a', {
    staticClass: "v5-checklist-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")])]), _vm._v(" "), _vm._t("extend"), _vm._v(" "), _c('div', {
    staticClass: "v5-checklist-main",
    class: {
      'v5-checklist-main-wrap': _vm.isShowFooter
    }
  }, _vm._l((_vm.currentData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "v5-checklist-content-wrap"
    }, [(_vm.level === 1 || index === _vm.level - 1) ? _c('x-checklist', {
      staticClass: "v5-checklist-content",
      attrs: {
        "options": item,
        "max": _vm.max
      },
      on: {
        "on-limit": _vm.limit
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var props = ref.props;

          return _c('span', {
            staticClass: "v5-checklist-content-item"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(props.name) + "\n\t\t\t\t\t")])
        }
      }], null, true),
      model: {
        value: (_vm.currentValue[index]),
        callback: function($$v) {
          _vm.$set(_vm.currentValue, index, $$v)
        },
        expression: "currentValue[index]"
      }
    }) : _c('x-radiolist', {
      staticClass: "v5-checklist-content",
      attrs: {
        "options": item
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var props = ref.props;

          return _c('span', {
            staticClass: "v5-checklist-content-item"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(props.name) + "\n\t\t\t\t\t")])
        }
      }], null, true),
      model: {
        value: (_vm.currentValue[index]),
        callback: function($$v) {
          _vm.$set(_vm.currentValue, index, $$v)
        },
        expression: "currentValue[index]"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('selected', {
    attrs: {
      "selects": _vm.currentValue[_vm.level - 1],
      "max": _vm.max
    },
    on: {
      "update": _vm.updateValue,
      "confirm": _vm.confirm
    },
    model: {
      value: (_vm.isShowFooter),
      callback: function($$v) {
        _vm.isShowFooter = $$v
      },
      expression: "isShowFooter"
    }
  }), _vm._v(" "), _c('toast', {
    model: {
      value: (_vm.isShowToast),
      callback: function($$v) {
        _vm.isShowToast = $$v
      },
      expression: "isShowToast"
    }
  }, [_vm._v("最多只能选择" + _vm._s(_vm.max) + "个")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb384814","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/checklist/index.vue
// module id = 373
// module chunks = 0